import React from "react"
import { Autocomplete as MUIAutocomplete } from "@mui/material"
import MUIMappedAutocomplete from "./mantine/Autocomplete.mantine"

export type AutocompleteProps =
  | ({ new?: false } & React.ComponentProps<typeof MUIAutocomplete>)
  | ({ new: true } & React.ComponentProps<typeof MUIAutocomplete>)

export const Autocomplete = React.forwardRef<HTMLDivElement, AutocompleteProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedAutocomplete {...props} ref={ref} />
    ) : (
      <MUIAutocomplete {...props} ref={ref} />
    ),
)

Autocomplete.displayName = "Autocomplete"

export default Autocomplete
